/*
  Kiwi UX, 2026-10-21 (Gaurav, after comparing timberland.com and bruntworkwear.com).
  Three jobs, one file. Styles: assets/kiwi-ux.css. Loaded once in the head from
  snippets/kiwi-forms-css.liquid.

  1. Collection card photo arrows. On a card with two or more photos, prev and next arrows fade in
     on hover and a thin bar along the bottom of the photo shows which photo is up. Clicking an
     arrow changes the photo and never opens the product. On touch screens the arrows are hidden,
     the bar always shows and a sideways swipe changes the photo. Every product photo is reachable
     (up to 15): snippets/product-grid-item-variant.liquid renders the first five (the hidden ones
     inside <template>) and lists the rest in data-kw-more as "mediaId~url|"; those load only when
     the shopper reaches them.

  2. Product page gallery (desktop, 750px and up). One row of photos that scrolls sideways, about
     1.35 photos in view, with arrows and a position bar under it, like timberland.com. The theme's
     Grid layout (templates/product.json, layout none@columns) supplies the markup; kiwi-ux.css
     turns it into the row. Phones keep the theme's own swipe gallery.

  3. Collection grid tiles (snippets/kiwi-grid-tiles.liquid). Every tile is one cell. With the
     grid's live column count, the most Card tiles that fit are kept and Filler tiles (rendered
     after the last product) make up the last row, so every row is full. Full-width banners take
     their own row and are not counted.

  4. Product page layout (desktop, photos and buy box side by side). The technology icons,
     standards badges, Description, Specifications and the tabs move under the photos, and the buy
     box stays in view beside them until they end, like timberland.com.
*/
(function () {
  if (window.__kwUx) return;
  window.__kwUx = true;

  var CHEV_L = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M7.5 2.5 4 6l3.5 3.5"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4.5 2.5 8 6 4.5 9.5"/></svg>';

  function btn(cls, label, svg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = svg;
    return b;
  }

  /* ---------- 1. Card photo arrows ---------- */

  function slides(card) {
    var box = card.querySelector('[data-grid-images]');
    if (!box) return [];
    return Array.prototype.filter.call(box.children, function (el) {
      return el.classList && el.classList.contains('product-grid-item__image-wrapper');
    });
  }

  function current(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function hydrate(card, w) {
    if (!w) return;
    var src = w.getAttribute('data-kw-src');
    if (src) {
      if (w.firstElementChild) return;
      var model = null;
      slides(card).some(function (s) {
        if (s !== w && s.querySelector('img')) { model = s.firstElementChild; return true; }
        return false;
      });
      if (!model) return;
      var copy = model.cloneNode(true);
      var img = copy.tagName === 'IMG' ? copy : copy.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'low');
        img.src = src;
      }
      w.appendChild(copy);
      return;
    }
    var t = null;
    for (var i = 0; i < w.children.length; i++) {
      if (w.children[i].tagName === 'TEMPLATE') { t = w.children[i]; break; }
    }
    if (t) {
      w.appendChild(t.content.cloneNode(true));
      t.parentNode.removeChild(t);
    }
  }

  function show(card, idx) {
    var list = slides(card);
    if (list.length < 2) return;
    var n = (idx % list.length + list.length) % list.length;
    hydrate(card, list[n]);
    hydrate(card, list[(n + 1) % list.length]);
    list.forEach(function (w, i) {
      var on = i === n;
      w.classList.toggle('is-active', on);
      if (on) w.setAttribute('data-grid-current-image', '');
      else w.removeAttribute('data-grid-current-image');
    });
    var bar = card.querySelector('.kw-cp-bar');
    if (bar) {
      Array.prototype.forEach.call(bar.children, function (s, i) {
        s.classList.toggle('is-on', i === n);
      });
    }
  }

  function addMore(card) {
    var box = card.querySelector('[data-grid-images]');
    var more = box && box.getAttribute('data-kw-more');
    if (!more) return;
    var have = {};
    slides(card).forEach(function (s) {
      var id = s.getAttribute('data-grid-image-target');
      if (id) have[id] = true;
    });
    var model = slides(card)[0];
    more.split('|').forEach(function (pair) {
      var i = pair.indexOf('~');
      if (i < 1) return;
      var id = pair.slice(0, i), url = pair.slice(i + 1);
      if (!url || have[id]) return;
      have[id] = true;
      var w = document.createElement('div');
      w.className = 'product-grid-item__image-wrapper';
      if (model && model.getAttribute('style')) w.setAttribute('style', model.getAttribute('style'));
      w.setAttribute('data-grid-image-target', id);
      w.setAttribute('data-kw-src', url);
      box.appendChild(w);
    });
  }

  function build(card) {
    if (card.hasAttribute('data-kw-cp')) return;
    card.setAttribute('data-kw-cp', '');
    addMore(card);
    var list = slides(card);
    if (list.length < 2) return;
    var host = card.querySelector('.product-grid-item__container');
    if (!host) return;
    card.setAttribute('data-kw-cp-on', '');

    var bar = document.createElement('div');
    bar.className = 'kw-cp-bar';
    bar.setAttribute('aria-hidden', 'true');
    var cur = current(list);
    card.__kwHome = cur;
    list.forEach(function (_, i) {
      var s = document.createElement('span');
      if (i === cur) s.className = 'is-on';
      bar.appendChild(s);
    });

    host.appendChild(btn('kw-cp kw-cp--prev', 'Previous photo', CHEV_L));
    host.appendChild(btn('kw-cp kw-cp--next', 'Next photo', CHEV_R));
    host.appendChild(bar);
  }

  function scanCards() {
    var cards = document.querySelectorAll('product-grid-item-variant:not([data-kw-cp])');
    for (var i = 0; i < cards.length; i++) build(cards[i]);
  }

  // Arrow clicks. Capture phase, so the card link underneath never sees the click.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.kw-cp') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var card = b.closest('product-grid-item-variant');
    if (!card) return;
    show(card, current(slides(card)) + (b.classList.contains('kw-cp--next') ? 1 : -1));
  }, true);

  // Warm the next photo when the pointer arrives, so the first arrow click is instant.
  document.addEventListener('mouseover', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('product-grid-item-variant[data-kw-cp-on]') : null;
    if (!card || card.__kwWarm) return;
    card.__kwWarm = true;
    var list = slides(card);
    hydrate(card, list[(current(list) + 1) % list.length]);
  });

  // 2026-10-26 (Gaurav: after flicking through a card's photos and moving off, it sometimes went back
  // to the first photo and sometimes not; the theme's own hover swap only reset in some states): on a
  // mouse, leaving the card always brings back the photo it opened with.
  var hoverMq = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
  document.addEventListener('mouseout', function (e) {
    if (hoverMq && !hoverMq.matches) return;
    var card = e.target && e.target.closest ? e.target.closest('product-grid-item-variant[data-kw-cp-on]') : null;
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    // After the theme's own mouseleave swap, so the photo and the position bar both end on the same one.
    setTimeout(function () { show(card, card.__kwHome || 0); }, 0);
  });

  // Sideways swipe on a card photo (touch screens).
  var sx = 0, sy = 0, sc = null;
  document.addEventListener('touchstart', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('product-grid-item-variant[data-kw-cp-on] [data-grid-images]') : null;
    sc = box ? box.closest('product-grid-item-variant') : null;
    // Inside a sideways product rail a swipe scrolls the rail, so it must not also change the photo.
    if (sc && sc.closest('.kw-rail__track, .kw-rail, .recent__content')) sc = null;
    if (!sc) return;
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!sc) return;
    var c = sc;
    sc = null;
    var t = e.changedTouches[0];
    var dx = t.clientX - sx, dy = t.clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      show(c, current(slides(c)) + (dx < 0 ? 1 : -1));
      c.__kwSwiped = Date.now();
    }
  }, { passive: true });

  // A swipe must not also open the product.
  document.addEventListener('click', function (e) {
    var c = e.target && e.target.closest ? e.target.closest('product-grid-item-variant') : null;
    if (c && c.__kwSwiped && Date.now() - c.__kwSwiped < 500) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* ---------- 2. Product page gallery row ---------- */

  function buildGallery() {
    var row = document.querySelector('[data-product-slideshow].product__grid--columns');
    if (!row || row.hasAttribute('data-kw-pg')) return;
    var items = Array.prototype.filter.call(row.children, function (el) {
      return el.classList.contains('product__media');
    });
    row.setAttribute('data-kw-pg', '');
    if (items.length < 2) return;
    var holder = row.parentElement;
    holder.classList.add('kw-pg');

    var prev = btn('kw-pg-btn kw-pg-btn--prev', 'Previous photo', CHEV_L);
    var next = btn('kw-pg-btn kw-pg-btn--next', 'Next photo', CHEV_R);
    var bar = document.createElement('div');
    bar.className = 'kw-pg-bar';
    bar.setAttribute('aria-hidden', 'true');
    items.forEach(function () { bar.appendChild(document.createElement('span')); });
    holder.appendChild(prev);
    holder.appendChild(next);
    row.insertAdjacentElement('afterend', bar);

    function visible() {
      return items.filter(function (el) { return el.offsetParent !== null && el.offsetWidth > 0; });
    }
    function aspectOf(el) {
      var a = parseFloat(el.getAttribute('data-aspect-ratio'));
      if (!a) {
        var im = el.querySelector('img');
        if (im && im.naturalWidth) a = im.naturalWidth / im.naturalHeight;
      }
      return a > 0 ? a : 0.8;
    }
    function lefts() {
      var v = visible();
      var base = v.length ? v[0].offsetLeft : 0;
      return v.map(function (el) { return el.offsetLeft - base; });
    }
    function curIndex() {
      var L = lefts(), s = row.scrollLeft, best = 0;
      L.forEach(function (x, i) { if (Math.abs(x - s) < Math.abs(L[best] - s)) best = i; });
      return best;
    }
    function go(d) {
      var L = lefts();
      if (!L.length) return;
      var i = Math.max(0, Math.min(L.length - 1, curIndex() + d));
      row.scrollTo({ left: L[i], behavior: 'smooth' });
    }
    function place() {
      // Every frame takes its photo's own shape, so there are no bars beside a photo (Gaurav,
      // 2026-10-21). Height is what the screen allows below the header, so a whole photo is in view
      // on a laptop without scrolling, and never more than a 4:5 photo at 74% of the row. A frame
      // is at most 90% of the row wide; a wide video gets a shorter frame instead of bars.
      var docTop = row.getBoundingClientRect().top + window.scrollY;
      var rw = row.clientWidth;
      var h = Math.max(380, Math.min(rw * 0.74 * 1.25, window.innerHeight - docTop - 24));
      visible().forEach(function (el) {
        var a = aspectOf(el);
        var w = Math.min(h * a, rw * 0.9);
        el.style.setProperty('--kw-w', Math.round(w) + 'px');
        el.style.setProperty('--kw-h', Math.round(w / a) + 'px');
      });
      var top = row.offsetTop + row.offsetHeight / 2;
      prev.style.top = next.style.top = top + 'px';
    }
    function sync() {
      var v = visible();
      var idx = curIndex();
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      if (atEnd) idx = v.length - 1;
      Array.prototype.forEach.call(bar.children, function (el, i) {
        el.style.display = i < v.length ? '' : 'none';
        el.classList.toggle('is-on', i === idx);
      });
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = atEnd;
    }
    row.addEventListener('load', function (e) {
      if (e.target && e.target.tagName === 'IMG') place();
    }, true);
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    row.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { place(); sync(); });
    if (window.ResizeObserver) new ResizeObserver(function () { place(); sync(); }).observe(row);
    place();
    sync();
  }

  /* ---------- 3. Grid tile balancing ---------- */

  function hrefOf(cell) {
    var a = cell.querySelector('a');
    return a ? a.getAttribute('href') : '';
  }

  function balance() {
    var grids = document.querySelectorAll('.js-grid');
    Array.prototype.forEach.call(grids, function (grid) {
      var kids = Array.prototype.slice.call(grid.children);
      var cards = kids.filter(function (el) {
        return el.classList.contains('kgt-cell') && !el.classList.contains('kgt-cell--banner') && !el.classList.contains('kgt-cell--filler');
      });
      var fillers = kids.filter(function (el) { return el.classList.contains('kgt-cell--filler'); });
      if (fillers.length && !grid.__kwSorted) {
        // Liquid renders fillers in admin order; put them in Position order, in the same place.
        grid.__kwSorted = true;
        var after = fillers[fillers.length - 1].nextSibling;
        fillers.sort(function (a, b) { return (+a.getAttribute('data-kgt-order') || 0) - (+b.getAttribute('data-kgt-order') || 0); });
        fillers.forEach(function (f) { grid.insertBefore(f, after); });
      }
      if (!cards.length && !fillers.length) return;
      var products = kids.filter(function (el) {
        return !el.classList.contains('kgt-cell') && el.querySelector('product-grid-item') && getComputedStyle(el).display !== 'none';
      }).length;
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;

      // Keep as many cards as possible; fillers that do not repeat a kept card make up the row.
      var keep = cards.length, use = [];
      if (cols > 1) {
        var found = false;
        for (var k = cards.length; k >= 0 && !found; k--) {
          var need = (cols - (products + k) % cols) % cols;
          var taken = {};
          cards.slice(0, k).forEach(function (c) { taken[hrefOf(c)] = true; });
          var free = fillers.filter(function (f) { return !taken[hrefOf(f)]; });
          if (need <= free.length) { keep = k; use = free.slice(0, need); found = true; }
        }
        if (!found) { keep = cards.length; use = []; }
        // 2026-10-26 (Gaurav: a page with a page after it must end on a full row): tiles are spread by
        // snippets/kiwi-grid-tiles.liquid, which gives such pages a multiple of 4 and marks them with
        // .kgt-more. There the most tiles that close the last row are kept (bottom ones go first). The
        // last page keeps every tile; a short last row there is the end of the collection.
        if (!fillers.length) {
          keep = cards.length;
          if (grid.querySelector('.kgt-more')) {
            for (var kk = cards.length; kk >= 0; kk--) { if ((products + kk) % cols === 0) { keep = kk; break; } }
          }
        }
      }
      cards.forEach(function (c, i) { c.classList.toggle('kgt-cell--off', i >= keep); });
      fillers.forEach(function (f) { f.classList.toggle('kgt-cell--on', use.indexOf(f) > -1); });

      // 2026-10-25 (Gaurav: the tiles always sat in the right-most column): tiles 8 products apart
      // land in the same column on a 4 or 2 across grid. Each card tile moves up to (columns - 1)
      // products later from where Liquid put it, to the first spot whose column differs from the
      // tile before it (and the one before that, with 3 or more columns). Its home spot is kept,
      // so a resize to a different column count works out again from the same start.
      if (cols > 1) {
        var prods = kids.filter(function (el) { return !el.classList.contains('kgt-cell') && el.querySelector('product-grid-item') && getComputedStyle(el).display !== 'none'; });
        var live = cards.filter(function (c) { return !c.classList.contains('kgt-cell--off'); });
        live.forEach(function (c) {
          if (c.getAttribute('data-kgt-home') === null) {
            var n = 0, el = c.previousElementSibling;
            while (el) { if (prods.indexOf(el) > -1) n++; el = el.previousElementSibling; }
            c.setAttribute('data-kgt-home', n);
          }
        });
        var prev1 = -1, prev2 = -1, plan2 = [];
        live.forEach(function (c, i) {
          var home = +c.getAttribute('data-kgt-home'), pick = home;
          for (var d = 0; d < cols; d++) {
            var p = Math.min(home + d, prods.length), col = (p + i) % cols;
            if (col !== prev1 && (cols < 3 || col !== prev2)) { pick = p; break; }
          }
          plan2.push(pick); prev2 = prev1; prev1 = (pick + i) % cols;
        });
        var sig2 = cols + ':' + prods.length + ':' + plan2.join(',');
        if (grid.__kwColSig !== sig2) {
          grid.__kwColSig = sig2;
          live.forEach(function (c, i) {
            var before = prods[plan2[i]] || null;
            if (before) grid.insertBefore(c, before);
            else if (prods.length) grid.insertBefore(c, prods[prods.length - 1].nextSibling);
          });
        }
      }

      // 2026-10-22 (Gaurav: tiles never next to or close to each other): spread the fillers in use
      // through the end of the grid, at least GAP cells from each other and from any card tile
      // (snippets/kiwi-grid-tiles.liquid spaces the cards the same way). Falls back to the end of
      // the grid when there is not enough room.
      if (use.length) {
        var GAP = 8;
        var cells = Array.prototype.slice.call(grid.children).filter(function (el) {
          if (el.classList.contains('kgt-cell--filler') || el.classList.contains('kgt-cell--off')) return false;
          return getComputedStyle(el).display !== 'none';
        });
        var cardAt = [];
        cells.forEach(function (el, i) { if (el.classList.contains('kgt-cell')) cardAt.push(i); });
        // Widest spacing that fits: try GAP cells first, then a little less, down to one row apart.
        var plan = function (gap) {
          var near = function (s) {
            return cardAt.some(function (c) { return (c < s ? s - c : c - s + 1) < gap; });
          };
          // 2026-10-25: a filler's column also differs from the tile after it and the card tile
          // before it (filler u ends up at cell s + u, as the earlier fillers go in ahead of it).
          var lastCol = -1;
          var colOk = function (s, u) {
            var col = (s + u) % cols, prevCard = -1;
            cardAt.forEach(function (c) { if (c < s) prevCard = c; });
            return col !== lastCol && (prevCard < 0 || prevCard % cols !== col);
          };
          var limit = cells.length, out = [];
          for (var u = use.length - 1; u >= 0; u--) {
            var s = limit;
            while (s > 0 && (near(s) || !colOk(s, u))) s--;
            if (s > 0) lastCol = (s + u) % cols;
            if (s <= 0) return null;
            out.unshift(s);
            limit = s - gap + 1;
            if (u > 0 && limit <= 0) return null;
          }
          return out;
        };
        var spots = null;
        for (var g = GAP; g >= Math.max(2, cols + 1) && !spots; g--) spots = plan(g);
        if (!spots) { spots = use.map(function () { return cells.length; }); }
        var sig = cells.length + ':' + spots.join(',') + ':' + use.map(function (f) { return f.getAttribute('data-kgt-order'); }).join(',');
        if (grid.__kwFillSig !== sig) {
          grid.__kwFillSig = sig;
          var tail = cells.length ? cells[cells.length - 1].nextSibling : null;
          use.forEach(function (f, j) { grid.insertBefore(f, cells[spots[j]] || tail); });
        }
      }
      grid.classList.add('kgt-grid');
    });
  }

  var balTimer = null;
  function balanceSoon() {
    clearTimeout(balTimer);
    balTimer = setTimeout(balance, 60);
  }
  window.addEventListener('resize', balanceSoon);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-toggle-grid]')) setTimeout(balance, 120);
  });

  /* ---------- 4. Product page: details under the photos, buy box pinned beside them ---------- */
  // When the photos and the buy box sit side by side, these move into the photo column, in this
  // order: the coined technology icons (a Custom Liquid section right after the product), the
  // standards badges and the Description (blocks in the buy box), Specifications and standards,
  // the Care / Size Chart / Instructions tabs, and Complete Your Setup. The buy box then stays in view while they scroll
  // past: a box shorter than the window pins at the top, a taller one scrolls until its bottom is
  // in view and pins there, so Add to Cart stays on screen. On narrow screens everything goes back.

  var under = null, moved = [];

  function underTargets() {
    var inner = document.querySelector('.product__inner');
    function sec(part, needs) {
      var all = document.querySelectorAll('.shopify-section[id*="' + part + '"]');
      for (var i = 0; i < all.length; i++) {
        if (!needs || all[i].querySelector(needs)) return all[i];
      }
      return null;
    }
    function blk(sel) {
      var el = inner && inner.querySelector(sel);
      while (el && el.parentElement !== inner) el = el.parentElement;
      return el;
    }
    return [
      sec('__section_liquid_', '.product-cert-icons'),
      blk('.product-cert-icons'),
      blk('.product__block__description'),
      sec('__kiwi_pdp_specs'),
      sec('__section_tabs_'),
      blk('.product__block__upsell')
    ].filter(Boolean);
  }

  function pin() {
    var inner = document.querySelector('.product__inner.is-sticky');
    if (!inner) return;
    if (!under) { inner.style.top = ''; return; }
    inner.style.top = Math.min(30, window.innerHeight - inner.offsetHeight - 24) + 'px';
  }

  function pdpLayout() {
    var wrap = document.querySelector('.product__media__wrapper');
    var main = document.querySelector('.product__main__content');
    if (!wrap || !main) return;
    var side = wrap.getBoundingClientRect().right <= main.getBoundingClientRect().left + 5;
    if (side && !under) {
      var list = underTargets();
      if (!list.length) return;
      under = document.createElement('div');
      under.className = 'kw-under';
      list.forEach(function (el) {
        var mark = document.createComment('kw-under');
        el.parentNode.insertBefore(mark, el);
        moved.push([el, mark]);
        under.appendChild(el);
      });
      wrap.appendChild(under);
      document.documentElement.classList.add('kw-pdp-stack');
      var inner = document.querySelector('.product__inner.is-sticky');
      if (inner && window.ResizeObserver && !inner.__kwRo) {
        inner.__kwRo = new ResizeObserver(pin);
        inner.__kwRo.observe(inner);
      }
    } else if (!side && under) {
      moved.forEach(function (p) {
        p[1].parentNode.insertBefore(p[0], p[1]);
        p[1].parentNode.removeChild(p[1]);
      });
      moved = [];
      under.parentNode.removeChild(under);
      under = null;
      document.documentElement.classList.remove('kw-pdp-stack');
    }
    pin();
  }

  var pdpTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(pdpTimer);
    pdpTimer = setTimeout(pdpLayout, 100);
  });

  /* ---------- 5. Product videos: adaptive stream in every browser ---------- */
  // snippets/media.liquid puts Shopify's adaptive stream (m3u8) first. Browsers that cannot play it
  // natively fall back to the 1080p file and buffer on slower connections; for those, the first
  // press of play loads hls.js (assets/kiwi-hls.min.js, about 300 KB, only then) and switches the
  // video to the adaptive stream, which starts at a quality the connection can hold.

  var hlsLoading = null;
  function loadHls(url) {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsLoading) {
      hlsLoading = new Promise(function (ok, fail) {
        var s = document.createElement('script');
        s.src = url;
        s.onload = function () { window.Hls ? ok(window.Hls) : fail(); };
        s.onerror = fail;
        document.head.appendChild(s);
      });
    }
    return hlsLoading;
  }

  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || !v.hasAttribute('data-kw-hls') || v.__kwHls) return;
    v.__kwHls = true;
    // 2026-10-22: large and Retina screens on a good connection play the sharper 1440p copy when the
    // video has one (data-kw-hd, from snippets/media.liquid). Shopify's own files stop at 1080p.
    var hd = v.getAttribute('data-kw-hd');
    var con = navigator.connection || {};
    if (hd && window.innerWidth >= 750 && window.innerWidth * (window.devicePixelRatio || 1) > 1920 &&
        !con.saveData && !/(^|-)2g|3g/.test(con.effectiveType || '')) {
      var t0 = v.currentTime;
      v.pause();
      v.querySelectorAll('source').forEach(function (s) { s.remove(); });
      v.src = hd;
      v.addEventListener('loadedmetadata', function () { if (t0) v.currentTime = t0; v.play(); }, { once: true });
      v.load();
      return;
    }
    if (/\.m3u8/i.test(v.currentSrc || '')) return; // already on the adaptive stream (native)
    if (!window.MediaSource) return;
    var at = v.currentTime;
    v.pause();
    loadHls(v.getAttribute('data-kw-hlsjs')).then(function (Hls) {
      if (!Hls.isSupported()) { v.play(); return; }
      var hls = new Hls({ capLevelToPlayerSize: true, startLevel: -1 });
      hls.loadSource(v.getAttribute('data-kw-hls'));
      hls.attachMedia(v);
      hls.on(Hls.Events.MANIFEST_PARSED, function () {
        if (at) v.currentTime = at;
        v.play();
      });
    }, function () { v.play(); });
  }, true);

  /* ---------- 6. Product rails everywhere ---------- */
  // Gaurav 2026-10-22: every product scroller matches the product page's Related products row. This is
  // that row's script (sections/related.liquid), for rails marked .kw-rail--site: the prev/next buttons
  // show only when the row is wider than the screen, each press moves about a screen of cards, the mouse
  // can drag the row, and a drag never opens a product. Phones swipe; the buttons are hidden there.

  function railSetup(rail) {
    if (rail.hasAttribute('data-kw-bound')) return;
    rail.setAttribute('data-kw-bound', '');
    var track = rail.querySelector('[data-kw-track]');
    var nav = rail.querySelector('[data-kw-nav]');
    if (!track) return;
    var prev = nav && nav.querySelector('[data-kw-prev]');
    var next = nav && nav.querySelector('[data-kw-next]');
    function step() {
      var first = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = first ? first.getBoundingClientRect().width + gap : 300;
      var shown = Math.min(track.getBoundingClientRect().width, window.innerWidth - track.getBoundingClientRect().left);
      return Math.max(w, Math.floor(shown / w - 1) * w);
    }
    // Gaurav 2026-10-22: a row with fewer products than the screen holds (Trek and Trail has 4) sizes its
    // cards up to fill the row instead of leaving a gap. Fill = the product count, at least 3 columns on
    // desktop and 2 on phones, so one or two products never blow up to half the screen.
    function fit() {
      var n = track.querySelectorAll(':scope > .kw-rail__item').length;
      track.classList.remove('kw-fit');
      var base = parseFloat(getComputedStyle(track).getPropertyValue('--kw-cols')) || 5.5;
      if (n && n < base) {
        track.classList.add('kw-fit');
        track.style.setProperty('--kw-fit', Math.max(n, base >= 3 ? 3 : 2));
      }
    }
    var lastW = -1;
    function update() {
      if (window.innerWidth !== lastW) { lastW = window.innerWidth; fit(); }
      if (!nav) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      nav.hidden = max <= 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('.kw-cp')) return; // card photo arrows stay clickable
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      setTimeout(function () { moved = false; }, 0);
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // Tabs (section-collection-tabs) show a hidden rail later; recheck when it becomes visible.
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
  }

  function scanRails() {
    var rails = document.querySelectorAll('.kw-rail--site[data-kw-rail]:not([data-kw-bound])');
    for (var i = 0; i < rails.length; i++) railSetup(rails[i]);
  }

  /* ---------- Pipeline card preload guard (2026-10-24) ----------
     Pipeline's product-grid-item-variant preloads one photo per child of its image holder and
     throws "No child element at index N" when the holder has more children than photos. Seen on
     desktop after paging Shop All by AJAX, on the live theme too. Skip the missing index instead. */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-grid-item-variant').then(function () {
      var PGV = customElements.get('product-grid-item-variant');
      if (!PGV || PGV.prototype.__kwSafePreload) return;
      var orig = PGV.prototype.preloadImage;
      PGV.prototype.preloadImage = function (index) {
        if (!this.images || ![].slice.call(this.images)[index]) return;
        return orig.call(this, index);
      };
      PGV.prototype.__kwSafePreload = true;
    });
  }

  /* ---------- start ---------- */

  function scan() {
    scanCards();
    buildGallery();
    pdpLayout();
    balance();
    scanRails();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  // Cards that arrive later (filters, sorting, pagination, product rows) get the same treatment.
  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(scan, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
